<div class="request-user-all-access-container">
  <div class="main-title" fiTranslation="USER_MANAGEMENT_DEACTIVATE_USER_HEADLINE" [params]="{
    UserName: data.user.User.FirstName + ' ' + data.user.User.LastName
  }"></div>
    <span class="deactivation-message" fiTranslation="USER_MANAGEMENT_DEACTIVATE_USER_MESSAGE"></span>
    <div>
     <div class="form-field select-form-fields">
       <span class="field-name" fiTranslation="USER_MANAGEMENT_DEACTIVATE_USER_DROPDOWN_REASON"></span>
       <div class="select-form">
         <div fiCustomSelect
              [class.error]="!selectedReason && isSubmitted"
              (value)="getReason($event)"
              [data]="reasons"
              [dataValueKey]="'Id'"
              [dataNameKey]="'Text'"
              class="select-field custom-select">
           <span class="selected-value placeholder"></span>
           <img src="assets/icons/arrow-down-dark.svg" alt="icon" class="arrow">

           <div class="options-cont">
             <ul class="options"></ul>
           </div>
         </div>
       </div>

     </div>
    <div>
      <div fiTranslation="USER_MANAGEMENT_DEACTIVATE_USER_TEXTFIELD_NOTE"></div>
      <textarea class="text-area" maxlength="2000" [(ngModel)]="text"></textarea>
    </div>

     <div class="submit-container">
       <button class="submit-btn" (click)="save()" >
         <img src="assets/icons/save-blue.svg" alt="save" class="icon" [matTooltip]="'Save Request'"
              matTooltipShowDelay="1000" matTooltipPosition="below" matTooltipClass='tooltip-style'>
         <span fiTranslation="USER_MANAGEMENT_DEACTIVATE_USER_BUTTON_SAVE"></span>
       </button>
     </div>

   </div>
  <button class="close-btn" (click)="matDialogClose()"></button>
</div>
